module.exports = __webpack_public_path__ + "static/img/zhangzy-erweima.69be8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhangzy-erweima.png
// module id = IjnX
// module chunks = 2